/* eslint-disable camelcase */
/*
 * 企業側 ホットライン相談申し込み 面談更新
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_SCHEDULE = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_SCHEDULE';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_RESCHEDULE = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_RESCHEDULE';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CANCEL = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CANCEL';
export const API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_BULK_CANCEL = 'API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_BULK_CANCEL';
/**
 * クライアント：ホットライン相談申し込み面談 受諾
 */
export const apiUpdateClientHotlineRequestInterviewSchedule = ({ path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_SCHEDULE, `/client/hotline/${id}/request/${hotline_request_id}/schedule/${hotline_request_interview_id}`, {}, meta);
/**
 * クライアント：ホットライン相談申し込み面談 再調整
 */
export const apiUpdateClientHotlineRequestInterviewReschedule = ({ json, path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_RESCHEDULE, `/client/hotline/${id}/request/${hotline_request_id}/reschedule/${hotline_request_interview_id}`, json, meta);
/**
 * クライアント：ホットライン相談申し込み面談 キャンセル
 */
export const apiUpdateClientHotlineRequestInterviewCancel = ({ json, path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_CANCEL, `/client/hotline/${id}/request/${hotline_request_id}/cancel/${hotline_request_interview_id}`, json, meta);
/**
 * クライアント：ホットライン相談申し込み面談 キャンセル（一括)
 */
export const apiUpdateClientHotlineRequestInterviewBulkCancel = ({ json, path: { id } }, meta) => apiUpdate(API_UPDATE_CLIENT_HOTLINE_REQUEST_INTERVIEW_BULK_CANCEL, `/client/hotline/${id}/request/bulk_cancel`, json, meta);
